import config from 'constants/config'

export default function useIsLoginV2Enabled(): boolean {
  return !!config.BUSINESS_TRAVELLER_LOGIN_V2_ENABLED
}
